// @Version: 1.0.0
import { Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { COLOR, IFieldItem, POSITION } from '../field-item.model';
import { FieldItemService } from '../field-item.service';

@Component({
   selector: 'app-field-item-text',
   templateUrl: './text.component.html',
   providers: [
         {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => FieldItemTextComponent)
      },
      {
         provide: NG_VALIDATORS,
         multi: true,
         useExisting: FieldItemTextComponent
      }
   ],
   standalone: false
})

export class FieldItemTextComponent implements OnDestroy, ControlValueAccessor {

   public COLOR = COLOR;
   public POSITION = POSITION;

   private fieldItem_: IFieldItem = {} as IFieldItem;

   @Input() 
   get fieldItem (): IFieldItem {
     return this.fieldItem_;
   }
   set fieldItem (value: IFieldItem) {
     this.fieldItem_ = value || {};
   }

   constructor (public sFieldItem: FieldItemService) { }

   ngOnDestroy (): void {
      this.fieldItem_= {} as IFieldItem;
   }

   validate (control: AbstractControl): ValidationErrors | null {
      return null;
   }

   writeValue (obj: any): void {
   }

   registerOnChange (fn: any): void { 
   }

   registerOnTouched (fn: any): void {  
   }

   setDisabledState (isDisabled: boolean | undefined): void {}
    
   private onTouched () {}

   private onChange (_: string) {}
}